import { render } from "./hrm-asset-category-modal.vue?vue&type=template&id=d6e233be"
import script from "./hrm-asset-category-modal.vue?vue&type=script&lang=js"
export * from "./hrm-asset-category-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__